<template>
	<v-form ref="personalInformation">
		<h3><translate>Personal information</translate></h3>
		<v-row>
			<v-col>
				<v-text-field
					v-model:model-value="personalInformationData.initials"
					color="primary"
					name="initials"
					:label="$gettext('Initials')"
					variant="outlined"
				/>
			</v-col>
			<v-col>
				<v-text-field
					v-model:model-value="personalInformationData.infix"
					color="primary"
					name="infix"
					:label="$gettext('Infix')"
					variant="outlined"
				/>
			</v-col>
			<v-col>
				<v-text-field
					v-model:model-value="personalInformationData.lastName"
					color="primary"
					name="lastName"
					:label="$gettext('Last Name')+'*'"
					:rules="[i => !!i ||'Please fill in your last name']"
					required
					variant="outlined"
				>
					<template #message="{ message }">
						{{ $gettext(message) }}
					</template>
				</v-text-field>
			</v-col>
			<v-col>
				<v-select
					v-model:model-value="personalInformationData.gender"
					:items="genderOptions"
					name="gender"
					color="primary"
					:label="$gettext('Gender')+'*'"
					:rules="[i => !!i || 'Please choose one of the available options']"
					required
					variant="outlined"
				>
					<template #message="{ message }">
						{{ $gettext(message) }}
					</template>
				</v-select>
			</v-col>
		</v-row>
		<v-row>
			<v-col>
				<v-text-field
					v-model:model-value="personalInformationData.phoneNumber"
					color="primary"
					name="phoneNumber"
					:label="$gettext('Phone number')+'*'"
					:rules="[i => !!i || 'Please fill in your phone number', i => /^\+(?:[0-9] ?){6,14}[0-9]$/.test(i) || $gettext('Telephone number must be in the international format and should start with a plus sign (+)')]"
					required
					variant="outlined"
				>
					<template #message="{ message }">
						{{ $gettext(message) }}
					</template>
				</v-text-field>
			</v-col>
			<v-col>
				<v-text-field
					v-model:model-value="personalInformationData.email"
					color="primary"
					name="email"
					:label="$gettext('Email address')+'*'"
					:rules="[i => !!i && emailRegex.test(i) || 'Please fill in your email']"
					required
					variant="outlined"
				>
					<template #message="{ message }">
						{{ $gettext(message) }}
					</template>
				</v-text-field>
			</v-col>
		</v-row>
	</v-form>
</template>

<script>
export default {
	name: 'PersonalInformationFields',
	props: {
		modelValue: {
			type: Object,
			default: () => null,
		}
	},

	emits: ['update:modelValue',],

	data () {
		return {
			personalInformationData: {
				gender: null,
				initials: '',
				infix: '',
				lastName: '',
				phoneNumber: '',
				email: '',
			},
			emailRegex: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
		};
	},

	computed: {
		genderOptions () {
			return [
				this.$gettext('Male'),
				this.$gettext('Female'),
			];
		}
	},

	watch: {
		personalInformationData: {

			/**
			 * Emit the personal information data when a change is detected
			 */
			handler () {
				this.$emit('update:modelValue', this.personalInformationData);
			},
			deep: true
		}
	},

	methods: {
		/**
		 * Checks whether all required fields are filled in
		 *
		 * @returns {boolean}
		 */
		async validate () {
			const {
				valid
			} = await this.$refs.personalInformation.validate();

			return valid;
		}

	}
};
</script>
